import { configureStore } from "@reduxjs/toolkit";
import bookingReducer from "./slice/features/bookingSlice";
import rootReducer from './slice/features/themeSlice';
import hotelReducer from "./slice/features/dropdownHotelSlice";
import facilityDetailReducer from "./slice/features/facilityDetailSlice"
import facilityReducer from "./slice/features/facilitySlice"
import paginationReducer from './slice/features/paginationSilce';
import destinationReducer from './slice/features/destinationSlice';
import districtReducer from './slice/features/districtSlice';
import footfallReducer from './slice/features/footfallSlice';
import cancelReducer from './slice/features/cancelSlice';
import reportReducer from "./slice/features/reportSlice";
import authReducer from "./slice/features/authSlice";
import hotelApi from "../api/hotelSlice";
import hotelDetailsSlice from "./slice/features/hotelDetailsSlice";
import availabilityReducer from "./slice/features/availabilitySlice";
import { cancellationPolicyApi } from "../api/fetchCancellationPolicy";
import cancelPageReducer from "./slice/features/showCancel";
import blockigReducer from "./slice/features/blockingSlice"
import hotelOccupancyReducer from "./slice/features/hotelOccupancySlice";
import menuReducer from "./slice/features/menuSlice";
import permissionReducer from "./slice/features/permissionSlice";

const store = configureStore({

  reducer: {
    booking: bookingReducer,
    blockings: blockigReducer,
    settings: rootReducer,
    hotels: hotelReducer,
    hotelDetails: hotelDetailsSlice,
    availability: availabilityReducer,
    facilityDetails: facilityDetailReducer,
    facility: facilityReducer,
    pagination: paginationReducer,
    cancelPage: cancelPageReducer,
    destination: destinationReducer,
    district: districtReducer,
    footfall: footfallReducer,
    hotelOcc: hotelOccupancyReducer,
    cancel: cancelReducer,
    report: reportReducer,
    auth: authReducer,
    menu: menuReducer,
    permission: permissionReducer,
    [hotelApi.reducerPath]: hotelApi.reducer,
    [cancellationPolicyApi.reducerPath]: cancellationPolicyApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(hotelApi.middleware)
      .concat(cancellationPolicyApi.middleware),
});

export default store;